import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducer';

export default function useCommunities() {
  return useSelector((state: RootState) => state.application.communities);
}
